const { getCurrentStage } = require('./common');

const DEFAULT_GEO = [ 'pp_us' ];

/**
 * The Geo data
 * @typedef {Object} Geo
 * @property {string} [name] - Geo-specific name - DEFAULT_GEO includes `[ 'pp_us' ]`.
 * @property {string} [nameLower] - Geo-specific name - lowercase version.
 * @property {string} domain - Geo-specific domain. (ex: paypal.com)
 * @property {string} cdnhost - Geo-specific CDN host. (ex: www.paypalobjects.com)
 * @property {string} ppinc - Geo-specific PayPal internal inc. domain. (ex: paypalinc.com)
 * @property {string} ppcorp - Geo-specific PayPal internal corp domain. (ex: paypalcorp.com)
 * @property {string} stage - Geo-specific staging host domain. (ex: msmaster.qa.paypal.com)
 */

/**
 * Returns Geo properties based on Geo name provided. 
 * 
 * @param {string} [name] - Geo name - usually comes from `process.env.instance_geo`.
 * @returns {Geo}
 * @throws Will throw if non-default Geo name is not found during `require(geoNameLower)`.
 */
function initGeo(name) {
    const nameLower = name && name.toLowerCase();
    const [ stage ] = getCurrentStage();
    const properties = {
        name,
        nameLower,
        domain: 'paypal.com',
        cdnhost: 'www.paypalobjects.com',
        ppinc: 'paypalinc.com',
        ppcorp: 'paypalcorp.com',
        stage
    };
    if (nameLower && !DEFAULT_GEO.includes(nameLower)) {
        try {
            const overrides = require(`./${nameLower}`);
            // function support helps with testability
            if (typeof overrides === 'function') {
                Object.assign(properties, overrides());
            } else {
                Object.assign(properties, overrides);
            }
        } catch (ex) {
            if (ex.code !== 'MODULE_NOT_FOUND') {
                throw ex;
            }
        }
    }
    // use instance_cdn_host env if it is set for override
    if (process.env.instance_cdn_host) {
        properties.cdnhost = process.env.instance_cdn_host;
    }
    return properties;
};

module.exports = { initGeo }
